// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const AcceptableUsePolicyPage = () => {
  return <LegalPageContent slug="acceptable-use-policy" fallbackTitle="Acceptable Use Policy" />;
};
